const prefix = '@votes';

export const VoteActionType = {
  Vote: `${prefix}/VOTE`,
  RemoveVote: `${prefix}/REMOVE_VOTE`,
  GetVoteInfo: `${prefix}/GET_VOTE_INFO`,
};
